<template>
	<modal ref="modal">
		<template #title>Material Details</template>
		<template #body>
			<div v-if="material" class="mb-5">
				<div
					v-if="material.card"
					class="overflow-hidden rounded mb-3 text-center bg-body-light border-start border-5 border-primary"
					:style="'background-image:url(' + material.card + ')'"
					style="
						height: 200px;
						background-size: contain;
						background-position: center;
						background-repeat: no-repeat;
					"
				/>
				<div v-if="material.category === 'gold_call'" class="mb-4">
					<VimeoIframe :videoId="material.video_id" />
				</div>
				<h3 class="fw-bold mb-2">{{ material.title }}</h3>
				<div class="fs-sm fw-medium text-muted mb-2">
					<span class="me-3">
						<i class="fa fa-fw fa-calendar-alt opacity-50 me-1"></i>
						{{ material.date_created }}
					</span>
					<span class="me-3">
						<i class="fa fa-fw fa-tag opacity-50 me-1"></i>
						{{ material.date_appear_formatted }}
					</span>
				</div>
				<p
					v-if="material.message"
					v-html="material.message"
					class="fs-sm mb-2"
				/>
				<ul class="nav nav-pills fw-bold">
					<li v-if="material.pdf" class="nav-item">
						<a
							class="me-3"
							:href="route('download', material.pdf)" target="_blank"
						>
							<i class="fa fa-fw fa-cloud-download-alt opacity-50 me-1"></i>Download
						</a>
					</li>
					<li v-if="material.video_id" class="nav-item">
						<a
							href="javascript:void(0)"
						>
							<i class="fa fa-fw fa-file-video opacity-50 me-1"></i>Watch Video
						</a>
					</li>
				</ul>
			</div>
		</template>
		<template #footer>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue'

export default {
	props: {
		material: Object,
	},
	setup() {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		return {
			modal,
			toggleModal,
		}
	},
}
</script>
